import React from 'react';

const Unauthorized = () => (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h1>403 - Unauthorized</h1>
        <p>You do not have permission to access this page.</p>
    </div>
);

export default Unauthorized;
